import * as yup from 'yup'
import { myDetailsGeneralStructure } from '../../../validation/user'

export const validation = yup.object().shape(myDetailsGeneralStructure)
